import {appLocalStorage, appSessionStorage} from "../../../shared/services";

const initialState = () => {
  return {
    currentStep: appLocalStorage.getItem('current-step'),
    showLoginForm: false,
    customerEmail: appLocalStorage.getItem('checkout-customer-email', null),
    extensionAttributes: appSessionStorage.getItem('checkout-extension-attributes', {}),
    emailDomainValid: true,
  };
}

const getters = {
  currentStep: state => state.currentStep,
  customerEmail: state => state.customerEmail,
  getShowLoginForm: state => state.showLoginForm,
  getExtensionAttributes: state => state.extensionAttributes,
  isEmailDomainValid: state => state.emailDomainValid,
};

const mutations = {
  TOGGLE_LOGIN_FORM(state) {
    state.showLoginForm = !state.showLoginForm;
  },
  SET_CURRENT_STEP(state, currentStep) {
    state.currentStep = currentStep;
    appLocalStorage.setItem('current-step', currentStep);

  },
  SET_CUSTOMER_EMAIL(state, customerEmail) {
    state.customerEmail = customerEmail;
    appLocalStorage.setItem('checkout-customer-email', customerEmail);
  },
  ADD_EXTENSION_ATTRIBUTE(state, extensionAttribute) {
    state.extensionAttributes = {...state.extensionAttributes, ...extensionAttribute};
    appSessionStorage.setItem('checkout-extension-attributes', state.extensionAttributes);
  },
  REMOVE_EXTENSION_ATTRIBUTE(state, extensionAttribute) {
    if (state.extensionAttributes.hasOwnProperty(extensionAttribute)) {
      delete state.extensionAttributes[extensionAttribute];
    }
    appSessionStorage.setItem('checkout-extension-attributes', state.extensionAttributes);
  },
  CLEAR_EXTENSION_ATTRIBUTE(state) {
    state.extensionAttributes = {};
    appSessionStorage.removeItem('checkout-extension-attributes');
  },
  SET_EMAIL_DOMAIN_VALIDATION(state, valid) {
    state.emailDomainValid = valid;
  },
};

const actions = {
  async checkCustomerEmail({state, commit, rootState}, customerEmail) {
    commit('SET_EMAIL_DOMAIN_VALIDATION', true);

    try {
      const response = await this.$solarClient.post(`/api/checkout/customers/isEmailAvailable`,
        {
          customerEmail: customerEmail,
        }
      );

      if (response.data && typeof response.data === 'object' && 'available' in response.data) {
        commit('SET_EMAIL_DOMAIN_VALIDATION', response.data.valid);

        return { data: response.data.available };
      }

      commit('SET_EMAIL_DOMAIN_VALIDATION', true);
      return response;
    } catch (e) {
      commit('SET_EMAIL_DOMAIN_VALIDATION', true);
      return false;
    }
  },
  async assignCustomerEmailToQuote({ state, rootState, rootGetters, commit }, customerEmail) {
    try {
      await this.$solarClient.post(`/api/checkout/quote/assign-email`, {
        customerData: {
          email: customerEmail,
        }
      });

      return true;
    } catch (e) {
      return false;
    }
  },
  async newsletterSubscribe({state, commit}, newsletterSubscribe) {
    commit('ADD_EXTENSION_ATTRIBUTE', {
      newsletter_subscribe: newsletterSubscribe,
    });
  },
  async gotoStep({state, commit}, step) {
    commit('SET_CURRENT_STEP', step);
  },
  toggleLoginForm({commit}) {
    commit('TOGGLE_LOGIN_FORM');
  }
}

const state = initialState();

const CheckoutGlobal = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default CheckoutGlobal;
